<template>
  <div class="app-hdr">
    <div class="no-drag-line top-resize"></div>

    <mac-left-space />

    <div class="left-ctn">
      <slot class="sl" />
      <slot name="center" class="sl" />
      <slot name="right" class="sl" />
    </div>

    <div class="right-ctn">
      <div v-if="isElectron" class="right-drag-area" @dblclick="toggleMaxWinOnMac">
        <div class="top-resize"></div>
      </div>
      <slot name="ctrl" class="sl" />
      <winCtrl class="win-ctrl" v-if="isElectron" v-show="os === 'win32' || os === 'linux'" />
    </div>
  </div>
</template>

<script>
import macLeftSpace from './macLeftSpace.vue'
import winCtrl from './winCtrl.vue'

export default {
  name: "appHdr",
  components: {
    winCtrl,
    macLeftSpace,
  },
  data() {
    return {
      os: this.utils.runtime.os,
      isElectron: this.utils.runtime.isElectron,
    }
  },
  methods: {
    toggleMaxWinOnMac: function(...args) {
      this.utils.electron.toggleMaxWinOnMac(...args)
    },
  }
}
</script>

<style scoped>
.app-hdr {
  height: 30px;
  -webkit-app-region: drag;

  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-ctn {
  flex-grow: 1;
  flex-shrink: 1;

  display: flex;
  justify-content: space-between;
}
.right-ctn {
  flex-shrink: 0;
  
  display: flex;
  justify-content: space-between;
  -webkit-app-region: no-drag;
}

.sl {
  -webkit-app-region: no-drag;
}
.right-drag-area {
  height: 30px;
  width: 45px;
  -webkit-app-region: drag;
}
.win-ctrl {
  -webkit-app-region: no-drag;
}
.top-resize {
  height: 5px;
  -webkit-app-region: no-drag;
  /* background-color: #fff; */
}

.no-drag-line {
  position: absolute;
  width: 100%;
  top: 0;
}
</style>